import ShopLocalizationName from './ShopLocalizationName';
export default ShopLocalizationName;
